export default __webpack_public_path__ + "static/SR India - Halal Decree - Indonesian Council of Ulama - Certificate-1a9a52ddbe56766c53ca5dc0a7ca9bb4.pdf";